import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Loader2 } from "lucide-react";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger,
} from "../ui/dialog";
import { FolderPlus } from "lucide-react";

export function CategoryDialog({ open, onOpenChange, form, setForm, onSubmit, saving }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button variant="outline" data-testid="add-category-btn">
          <FolderPlus className="w-4 h-4 mr-2" /> Categoria
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Nueva categoria</DialogTitle>
          <DialogDescription>Añade una categoria para organizar tus platos</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label>Nombre *</Label>
            <Input placeholder="Ej: Entrantes, Principales, Postres..."
              value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
              data-testid="category-name-input" />
          </div>
          <div className="space-y-2">
            <Label>Descripcion</Label>
            <Input placeholder="Descripcion opcional"
              value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
          </div>
          <div className="flex gap-3 justify-end">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
            <Button type="submit" disabled={saving}>
              {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Crear"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
